import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, TextInput } from '../../../types'
import { CmsConverterService, defaultFSCatalog, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class TimelineConverter extends CmsConverterService<TimelineData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      teaserText: formData.st_teaser_text ?? defaultTextInput,
      label: formData.st_label ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      footnote: formData.st_footnote ?? defaultTextInput,
      items: formData.st_items ?? defaultFSCatalog
    }
  }
}

export const TIMELINE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, TimelineData>>('TimelineConverter')

export interface TimelineData extends ConvertedComponentData {
  teaserText: TextInput;
  label: TextInput;
  headline: TextInput;
  footnote: TextInput;
  items: FsCatalog;
}
